<template>
    <div class="app">
        <div class="dyindex_box">
            <div class="about_cent">
                <div class="about_cents">
                    <div class="about_centst">
                        <div class="about_centsA">
                            <div class="about_centsAtop">
                                <h1>功能栏</h1>
                            </div>
                            <ul class="nav">
                                <li
                                    v-for="(item,index) in navList"
                                    :class="{active:!(index-menuIndex),'bor imast':clicked==index}"
                                    @click='menuShow(index)'
                                    :key="index"
                                >
                                    <p>{{item}}</p>
                                </li>
                            </ul>
                            <div class="navimgs">
                            </div>
                        </div>
                        <div class="about_centsB">
                            <div
                                class="about_navcont about_navcontsA"
                                v-show='menuIndex == 0'
                            >
                                <div class="about_centsAtop">
                                    <h1>发展历程</h1>
                                </div>

                            </div>
                            <div
                                class="about_navcont about_navcontsB"
                                v-show='menuIndex == 1'
                            >
                                <div class="about_centsAtop">
                                    <h1>网站公告</h1>
                                </div>
                                <div class="about_navAcentbox">
                                    <div class="about_navAcent">
                                        <ul>
                                            <li
                                                v-for="(item,index) in announcement"
                                                :key="index"
                                            >
                                                <div class="about_imgst"></div>
                                                <p>{{item.test}}</p>
                                                <span>{{item.time}}</span>
                                            </li>
                                            <!-- 	<li>
												<div class="about_imgst"></div>
												<p>大樱桃领跑大连机场货运“水果季”</p>
												<span>2016-04-28</span>
											</li> -->
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="about_navcont about_navcontsC"
                                v-show='menuIndex == 2'
                            >
                                <div class="about_centsAtop">
                                    <h1>新手上路</h1>
                                </div>
                                <div class="about_navAcentbox">
                                    <div class="about_navAcent">
                                        <ul>
                                            <li
                                                v-for="(item,index) in novice"
                                                :key="index"
                                            >
                                                <div class="about_imgst"></div>
                                                <p>{{item.test}}</p>
                                                <span>{{item.time}}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="about_navcont about_navcontsC"
                                v-show='menuIndex == 3'
                            >
                                <div class="about_centsAtop">
                                    <h1>付款方式</h1>
                                </div>
                                <div class="about_navAcentbox">
                                    <div class="about_navAcent">
                                        <ul>
                                            <li
                                                v-for="(item,index) in payment"
                                                :key="index"
                                            >
                                                <div class="about_imgst"></div>
                                                <p>{{item.test}}</p>
                                                <span>{{item.time}}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="about_navcont about_navcontsC"
                                v-show='menuIndex == 4'
                            >
                                <div class="about_centsAtop">
                                    <h1>配送信息</h1>
                                </div>
                                <div class="about_navAcentbox">
                                    <div class="about_navAcent">
                                        <ul>
                                            <li
                                                v-for="(item,index) in distribution"
                                                :key="index"
                                            >
                                                <div class="about_imgst"></div>
                                                <p>{{item.test}}</p>
                                                <span>{{item.time}}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="about_navcont about_navcontsC"
                                v-show='menuIndex == 5'
                            >
                                <div class="about_centsAtop">
                                    <h1>验货与拒收政策</h1>
                                </div>
                                <div class="about_gy">
                                    <div class="about_gytop">
                                        <div class="about_gytoptest">
                                            <h4>关于我们</h4>
                                            <p>发布时间:2016-03-23 15:03:48</p>
                                        </div>
                                        <div class="about_gytopcents">
                                            <p>
                                                917蔬菜网是浙江成信集团旗下网站，是汇聚最新生鲜、水果、蔬菜、副食粮油的网上交易平台，
                                                由成信集团根据市场需求成功研发并投入市场。市场潜力巨大，采用各县市特许经营加盟的模式，
                                                给城市的新鲜生活带来了便捷，也为广大朋友送去了健康。
                                            </p>
                                        </div>
                                        <div class="about_gytopcent">
                                            <p>联系电话：<span>400-0579-693</span></p>
                                            <p>公司地址：<span>浙江省金华市婺城区新华街301号浙中信息产业园信息大厦2楼</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="about_boxs"></div>
    </div>
    </div>
    </div>
</template>

<script>
    export default
    {
        name: 'Index',
        data()
        {
            return {
                menuIndex: 0,
                navList: [ '发展历程', '网站公告', '新手上路', '付款方式', '配送信息', '关于我们' ],
                clicked: 0, // 标识，初始化默认选中第一项
                currentPage1: 5,
                currentPage2: 5,
                currentPage3: 5,
                currentPage4: 4,
                //网站公告
                announcement: [
                {
                    test: "新用户演示",
                    time: "2016-03-23"
                },
                {
                    test: "新用户演示",
                    time: "2016-03-23"
                },
                {
                    test: "新用户演示",
                    time: "2016-03-23"
                } ],
                // 新手上路
                novice: [
                {
                    test: "新手上路",
                    time: "2016-03-23"
                },
                {
                    test: "新手上路",
                    time: "2016-03-23"
                },
                {
                    test: "新手上路",
                    time: "2016-03-23"
                } ],
                //付款方式
                payment: [
                {
                    test: "支付常见问题",
                    time: "2016-03-23"
                },
                {
                    test: "支付方式",
                    time: "2016-03-23"
                } ],
                // 配送信息
                distribution: [
                {
                    test: "验货与拒收政策",
                    time: "2016-03-23"
                },
                {
                    test: "订单处理时间",
                    time: "2016-03-23"
                } ]
            }
        },
        mounted()
        {
            // console.log(this.$route.query.clicked)
            // console.log(this.$route.query.id)
            // console.log(this.$route.query.aboutlisid)
            if ( this.$route.query.clicked != undefined )
            {
                this.clicked = this.$route.query.clicked
                this.menuIndex = this.$route.query.clicked
            }
            else if ( this.$route.query.id != undefined )
            {
                this.clicked = this.$route.query.id
                this.menuIndex = this.$route.query.id
            }
            else
            {
                this.clicked = 0
                this.menuIndex = 0
            }
        },
        methods:
        {
            // 点击选选项卡内容切换
            menuShow( index )
            {
                this.menuIndex = index
                this.clicked = index
                console.log( this.clicked )
                console.log( this.menuIndex );
                // 循环点击事件
            },
        }

    }
</script>

<style scoped="scoped">
    .dyindex_box {
        width: 100%;
        height: 100%;
        background-color: #F1F1F1;
    }

    .about_cents {
        width: 100%;
        height: 100%;
        background-color: #F3F3F3;
        display: flex;
        justify-content: center;
    }

    .about_centst {
        width: 75rem;
        height: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 5rem;
    }

    .about_centsA {
        width: 18.25rem;
        height: 40.9375rem;
        background: #FFFFFF;
    }

    .about_centsB {
        width: 54.5rem;
        background: #FFFFFF;
        display: flex;
        justify-content: center;
    }

    /* 选项卡开始 */
    .nav {
        margin-top: 1rem;
    }

    .nav li {
        margin: 0.5rem 1rem;
        padding-left: 1rem;
        cursor: pointer;
        line-height: 3rem;
    }

    .bor {
        width: 15.2rem;
        height: 3rem;
        background: #E2F6E9;
        border: 2px solid #069338;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #1A5F32;

    }

    .imast {
        background-image: url(../../assets/image/iocn/icon3.png);
        background-repeat: no-repeat;
        background-position: 13rem 1rem;
    }

    /* 选项卡结束 */
    .about_navcont {
        width: 100%;
        height: 100%;
    }

    .about_boxs {
        width: 100%;
        height: 5rem;
        background-color: #F3F3F3;
    }

    .about_centsAtop {
        height: 5rem;
        border-bottom: 1px solid #999999;
    }

    .about_centsAtop h1 {
        width: 100%;
        font-size: 28px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
        border-left: 5px solid #069338;
        height: 1.5rem;
        padding-left: 1rem;
        position: absolute;
        margin-top: 2rem;
    }

    .about_gy {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 4rem;
    }

    .about_gytop {
        width: 52.9375rem;
        height: 15rem;
    }

    .about_gytoptest {
        width: 100%;
        height: 5rem;
        border-bottom: 1px solid #999999;
        text-align: center;
    }

    .about_gytoptest h4 {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 500;
        color: #333333;
        line-height: 30px;
    }

    .about_gytoptest p {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 200;
        color: #333333;
        line-height: 30px;
    }

    .about_gytopcents {
        width: 49.125rem;
        padding: 3rem 2rem;
    }

    .about_gytopcents p {
        text-indent: 2em;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 30px;
    }

    .about_gytopcent {
        padding: 2rem;
    }

    .about_gytopcent p {
        color: #069338;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
    }

    .about_gytopcent span {
        color: #069338;
    }

    .about_navAcentbox {
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .about_navAcent {
        width: 53.125rem;
    }

    .about_navAcent li {
        display: flex;
        justify-content: space-between;
        height: 3.75rem;
        border-bottom: 1px solid #BFBFBF;
        list-style-type: disc;
    }

    .about_navAcent p {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 4rem;
        margin-left: 1.5rem;
    }

    .about_navAcent p:hover {
        color: #069338;
        cursor: pointer;
    }

    .about_navAcent span {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 4rem;
    }

    .about_imgst {
        background: url('../../assets/image/iocn/iocnfont.png') no-repeat -334px -521px;
        width: 5px;
        height: 5px;
        position: absolute;
        margin: 1.8rem 0.5rem;
    }
</style>